import React from 'react';
import PaddingBox, { Side } from '@uds/padding-box';
import { Colorway } from '@uds/theme-utils';
import { Product } from '@uds/product';
import { useBreakpoints } from '@uds/responsive';
import { LegalText } from 'components/common/ProductPrice';
import { Layout } from 'domain/constants/layout';
import { PricingStrategy } from 'presentation/components/common/ProductPrice/constants';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';
import { Alignment } from 'domain/constants/alignment';

import CardLink, { SavingType } from './CardLink';
import getClassNames from './CardTag.stylesheet';

interface OuterProps {
  colorway: Colorway;
  product: Product;
  pricingStrategy: PricingStrategy;
  hBaseline: number;
  saving: SavingType;
  badge: string;
  url: string;
  layout: Layout;
}

const PureCardTag = ({ colorway, product, pricingStrategy, hBaseline, saving, badge, url, layout }: OuterProps) => {
  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  const classNames = getClassNames({ alignment });

  return (
    <div className={classNames.root}>
      <CardLink
        hBaseline={hBaseline}
        saving={saving}
        badge={badge}
        url={url}
        pricingStrategy={pricingStrategy}
        colorway={colorway}
        product={product}
        alignment={alignment}
      />
      <PaddingBox side={Side.X} className={classNames.legalCaveat}>
        <LegalText pricingStrategy={pricingStrategy} product={product} />
      </PaddingBox>
    </div>
  );
};

PureCardTag.displayName = 'CardTag';

export default PureCardTag;
